import { render, staticRenderFns } from "./AddUnionmember.vue?vue&type=template&id=fc6b5bb2&"
import script from "./AddUnionmember.vue?vue&type=script&lang=js&"
export * from "./AddUnionmember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports